/*
 * Project: LegalPlace assistant
 * File: src\components\progress.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

 // this component shows the progression of filling the contract

import React, { Component } from 'react';
import { connect } from 'react-redux';



// this one gets the level one object length
/**
 * Object a = {
 *  b: 1,
 *  c: 4
 * }
 * 
 * The length of first level is 2
 */
import { objectLength } from './utils/misc';
import lpApp from '../app/lp_app';


// TODO: to refactor the component
export class ProgressBar extends Component {
    params = new Object();
    constructor( props ) {
        super( props );

        // set initial progress
        this.params = { ...props }
        if( typeof this.params.progress == 'undefined' )
            this.params.progress = 0;
        // put the params
        this.params.progress *= 100;
        // this one contains (progress, total) tuples
        this.changes_history = [];
    }
    // Progress UX operations
    // checkProgressChange(new_sections){
    //     return (new_sections == this.props.progress)
    // }

    // pushChange(a, p, t){
    //     this.changes_history.push({
    //         actual: a,
    //         progress: p,
    //         total: t
    //     });
    // }

    // isEmptyHistory(){
    //     return this.changes_history.length == 0;
    // }

    // popChange(){
    //     return this.changes_history.pop();
    // }

    shouldComponentUpdate(nextProps, nextState){
        if(lpApp.action_tracker.last_action == 'SET_SECTION_ID')
            return true;
        return false;
    }

    // TODO: check if it's harmful to ommit the params variable, and ommit it
    componentWillMount() {
        this.params.progress = this.props.progress;
        this.params.progress_len = this.props.total_progress;
        
    }
    componentDidMount() {
        this.params.progress = this.props.progress;
        this.params.progress_len = this.props.total_progress;
        
    }
    componentWillUpdate(nextProps, nextState){
    }
    render() {
        // TODO: move the calculation to pre-update phase
        var s_ = 0;
            s_ = this.props.progress / this.props.total_progress;
        s_ *= 100;
        // this.pushChange(s_, this.props.total_progress)
        if(s_.toString() == "NaN")s_ = 0;
        var s = { width: s_ + '%' }
        return ( <div className="progress">
                    <div className={"progress-bar in " + (s_ >= 10 ? " in": "")} role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={s}>
                        {Math.round(s_) + "%"}
                    </div> 
                </div>);
        }
    }
    const style_ = {
        marginLeft: "10px",
        marginRight: "10px"
    }

//     <div className="progress-index white-text text-lighten-1" > 
//     { Math.round( s_ ) } 
// </div> 
    // FIXME: delete this component, it's useless
export const TLpProgressBar = ( props ) =>{
    var s_ = props.progress / props.total_progress;
    s_ *= 100;
    var s = {width: s_ + '%'}
    return (<div className={"pink lighten-4 progress-bar" + s_ <= 10 ? " in" : ""}
                style = { style_ }>
                <div className="progress-full pink lighten-2" style={ s } >
                <div className="progress-index white-text text-lighten-1" > 
                    { Math.round( s_ ) } 
                </div> 
            </div> 
        </div>);
        
}


// getting the progress information and put them into the component
const mapStateToProps = ( state ) => {
    window.tmp_0 = state.contract.sections;
    let total_progress = Object.keys(lpApp.indexes.real_sections.sections).length
    // let actual_change = state.contract.currentSection
    return {
        progress : state.contract.currentSection,
        total_progress: objectLength( state.contract.sections ),
        total_sections: total_progress
    }
}


// FIXME: rewrite the mapDispatchToProps
export const LpProgressBar = connect( mapStateToProps, ( dispatch ) => {return {}})( ProgressBar )


// WEBPACK FOOTER //
// ./src/components/progress.js